import { IExportColumnModel } from "../../../../shared/models";

export const ConfigurationsColumnList: IExportColumnModel[] = [
]